module.exports = __webpack_public_path__ + "media/images/icons/outlined/question-e858354a96fdce50029b78377567745f.svg";